import React from 'react';

const styles = {
  holder: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr',
    width: '100%',
    padding: '0.4rem'
  },
  lastText: {
    textAlign: 'right'
  },
  centerItem: {
    textAlign: 'center',
    position: 'relative',
    left: '-1rem'
  }
};

export default function StoreStats(props) {
  return (
    <div style={styles.holder}>
      <div>
        <i className='icons8-user' /> Total: 60
      </div>
      <div style={styles.centerItem}>
        <i className='icons8-user' /> Active: 50
      </div>
      <div style={styles.lastText}>
        <i className='icons8-user' /> Working: 40
      </div>
    </div>
  );
}
